import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navItems, logoText } from '../data/navigation';
import { fetchUser } from '@genfun/core';
import './Sidebar.css';

export function MobileHeader({ user, credits, onMenuClick, onLoginClick, onCreditsClick, onLogoClick }) {
    return (
        <header className="mobileHeader">
            <button className="mobileMenuBtn" onClick={onMenuClick}>
                <img src={`${process.env.PUBLIC_URL}/hamburger-menu.svg`} alt="Menu" />
            </button>

            <span className="mobileLogoText" onClick={onLogoClick} style={{ cursor: 'pointer' }}>
                {logoText.primary}
                <span className="redSidebarLogoAccent">{logoText.accent}</span>
            </span>

            {user ? (
                <button className="mobileCreditsBtn" onClick={onCreditsClick}>
                    <img src={`${process.env.PUBLIC_URL}/coins.svg`} alt="" />
                    <span>{credits}</span>
                </button>
            ) : (
                <button className="mobileLoginBtn" onClick={onLoginClick}>
                    Log in
                </button>
            )}
        </header>
    );
}

export function MobileMenu({ isOpen, onClose, currentPath, onNavigate, user, onSignOut }) {
    const handleNavClick = (path) => {
        onNavigate(path);
        onClose();
    };

    const handleSignOut = () => {
        onSignOut();
        onClose();
    };

    return (
        <div className={`mobileMenuOverlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div className="mobileMenuPanel" onClick={(e) => e.stopPropagation()}>
                <div className="mobileMenuHeader">
                    <span className="mobileLogoText">
                        {logoText.primary}
                        <span className="redSidebarLogoAccent">{logoText.accent}</span>
                    </span>
                    <button className="mobileMenuCloseBtn" onClick={onClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                <nav className="mobileMenuNav">
                    {navItems.map((item) => (
                        <a
                            key={item.path}
                            href={item.path}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavClick(item.path);
                            }}
                            className={`mobileMenuNavItem ${
                                currentPath === item.path ? 'mobileMenuNavItemActive' : ''
                            }`}
                        >
                            {item.text}
                        </a>
                    ))}
                </nav>

                {user && (
                    <div className="mobileMenuFooter">
                        <button className="mobileMenuSignOutBtn" onClick={handleSignOut}>
                            Sign out
                        </button>
                    </div>
                )}

                <div className="mobileMenuLegal">
                    <a
                        href="/take_it_down_report"
                        onClick={(e) => { e.preventDefault(); handleNavClick('/take_it_down_report'); }}
                        className="mobileMenuLegalLink"
                    >
                        Report content
                    </a>
                </div>
            </div>
        </div>
    );
}

export function RedSidebar({ token, user, setUser, setSignedIn, setToken, onCreditsClick, onSignInClick }) {
    const [credits, setCredits] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        let interval = null;
        if (token) {
            (async () => {
                const [u, status] = await fetchUser(token);
                if (status === 401) {
                    setUser(null);
                    setToken(null);
                    setSignedIn(false);
                }
                if (u) {
                    setUser(u);
                    setCredits(u.credits);
                }
            })();
            interval = setInterval(async () => {
                const [u, status] = await fetchUser(token);
                if (status === 401) {
                    setUser(null);
                    setToken(null);
                    setSignedIn(false);
                }
                if (u) {
                    setUser(u);
                    setCredits(u.credits);
                }
            }, 10000);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [token, setUser, setToken, setSignedIn]);

    const handleSignClick = () => {
        if (user) {
            setUser(null);
            setToken(null);
            setSignedIn(false);
            localStorage.removeItem("igenfuntoken");
        } else if (onSignInClick) {
            onSignInClick();
        } else {
            navigate('/login');
        }
    };

    const handleCreditsClick = () => {
        if (onCreditsClick) {
            onCreditsClick();
        } else {
            navigate('/pricing');
        }
    };

    const handleLogoClick = () => {
        navigate('/video');
    };

    const currentPath = location.pathname;

    return (
        <aside className="redSidebar">
            <div className="redSidebarLogo" onClick={handleLogoClick}>
                <span className="redSidebarLogoText">
                    {logoText.primary}
                    <span className="redSidebarLogoAccent">{logoText.accent}</span>
                </span>
            </div>

            <nav className="redSidebarNav">
                {navItems.map((item) => (
                    <a
                        key={item.path}
                        href={item.path}
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(item.path);
                        }}
                        className={`redSidebarNavItem ${
                            currentPath === item.path ? "redSidebarNavItemActive" : ""
                        }`}
                    >
                        {item.text}
                    </a>
                ))}
            </nav>

            <div className="redSidebarButtons">
                {user && (
                    <button
                        className="redSidebarCreditsBtn"
                        onClick={handleCreditsClick}
                    >
                        <img src={`${process.env.PUBLIC_URL}/coins.svg`} alt="" className="creditsIcon" />
                        {credits} credits
                    </button>
                )}
                <button className="redSidebarLoginBtn" onClick={handleSignClick}>
                    {user ? "Sign out" : "Log in"}
                </button>
            </div>

            <div className="redSidebarLegal">
                <a
                    href="/take_it_down_report"
                    onClick={(e) => { e.preventDefault(); navigate('/take_it_down_report'); }}
                    className="redSidebarLegalLink"
                >
                    Report content
                </a>
            </div>
        </aside>
    );
}
